import {
  Attribute,
  BooleanAttribute,
  MultipleChoiceAttribute,
  SingleChoiceAttribute,
  TextAttribute,
} from '../../../../team-apis/otterdam/taxonomy';

export function isBooleanAttribute(
  attribute: Attribute,
): attribute is BooleanAttribute {
  return attribute.__type === 'boolean_attribute';
}

export function isSingleChoiceAttribute(
  attribute: Attribute,
): attribute is SingleChoiceAttribute {
  return attribute.__type === 'single_choice_attribute';
}

export function isMultipleChoiceAttribute(
  attribute: Attribute,
): attribute is MultipleChoiceAttribute {
  return attribute.__type === 'multiple_choice_attribute';
}

export function isTextAttribute(
  attribute: Attribute,
): attribute is TextAttribute {
  return attribute.__type === 'text_attribute';
}
